import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/globals.css'
// Import tokenManager FIRST - its module init seeds the in-memory JWT from
// localStorage. This must happen before the router module (imported via
// `./App`) evaluates, because React Router v6.4+ runs route loaders
// synchronously during `createBrowserRouter()`. If the token isn't in
// memory at that moment, requireAuth() redirects to /login - which is the
// Google/Microsoft OAuth handoff regression.
import './lib/tokenManager'
import { App } from './App'

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root element in index.html')

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
